import { Typography, Link } from "@mui/joy";

function NewsTitle({ title, secondaryTitle }) {
  return (
    <>
      <Typography
        level="title-xs"
        sx={{
          mb: 0.5,
          textAlign: "left",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "20px",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        <Link overlay underline="none" href="#">
          {title}
        </Link>
      </Typography>

      <Typography
        level="body-xs"
        sx={{
          mb: 0.5,
          fontStyle: 'italic',
          color: 'neutral.500',
          textAlign: "left",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {secondaryTitle}
      </Typography>
    </>
  );
}

export default NewsTitle;